export const handleScroll = () => {
  const targetId = window?.location.hash.slice(1);

  if (targetId) {
    try {
      const position = document.querySelector(`#${targetId}`)?.offsetTop;

      if (position) {
        window.scrollTo(0, position);
      }
    } catch (err) {
      // Fragment and not a target section
    }
  }
};
